import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import ModalService from 'services/modal';
import OrderService from 'services/order';
import TopNav from 'components/topNav.js';
import Download from 'components/download.js';
import * as MobileActions from 'actions/index.ts';
import CommonFns from 'functions/common.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import DialogEditRequisitonLine from 'components/dialogEditRequisitionLine';
import DialogEditRequisiton from 'components/dialogEditRequisition';
import DialogAddProd from 'components/dialogAddProd';
import { ActionContext } from 'actions/context';
import EnumService from 'services/enum2';
import useDetail from 'hooks/useDetail';
import Modal from 'components/modal';
import CompanyService from 'services/company2';
//单头自定义字段
import HeadCustField from 'components/headCustField';
import BodydCustField from 'components/bodyCustField';
import CustFieldService from 'services/custField';
import Util from 'lib/util.js';
const isEmpty = Util.isEmpty;

function RequisitionDetail(props) {
  const Config = {
    purchase: {
      title: '请购单详情',
      apiPath: '/b2bRequisitionOrder/getDetail',
      enumMainKey: 'B02_Requisition_Order_Status',
      orderDetailLink: '/mp/purchase/order/detail',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Requisition_Type',
          subKey: 'reqType',
          value: 'reqTypeName'
        },
        {
          mainKey: 'B02_Requisition_Order_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'reqXkNo',
      wfmCode: '1022'
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    handleMore,
    decimalPlace,
    detail,
    setDetail,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    workflow,
    self
  } = useDetail(props, config);

  const [isOpenProfit, setIsOpenProfit] = useState(false);
  const [isOpenOrg, setIsOpenOrg] = useState(false);
  const { state, dispatch } = useContext(ActionContext);
  const [fieldSetting, setFieldSetting] = useState([]);
  const [edit, setEdit] = useState(false); // 单头编辑弹窗状态
  const [lineEdit, setLineEdit] = useState(false); // 单身编辑弹窗状态
  const [currItem, setCurrItem] = useState(null);
  const [showAddProd, setShowAddProd] = useState(false);
  const [lineList, setLineList] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [curCategoryType, setCurCategoryType] = useState(''); //请购需求池当前设置的分类

  //处理详情数据
  self.afterGetDetail = async function (data) {
    getIsOpenOrg(data.purCompanyCode);
    getCurCategoryType(data.purCompanyCode);
    await getFieldSetting(self.isPurchase ? companyCode : data.customerCode);

    //是否开启采购组织
    //let isOpenOrg = await CompanyService.checkOpenOrg(detail.purCompanyCode);

    // 处理单身数据
    if (Array.isArray(data.lineList)) {
      for (let item of data.lineList) {
        //采购类型
        await EnumService.getValue('B02_Purchase_Type', item.purchaseType).then(
          value => {
            item.purchaseTypeName = value;
            //setDetail(data);
          }
        );

        //转采数量
        let sum = 0;
        item.infoList.forEach(items => {
          sum += items.purchaseQty;
        });
        item.sumPurchaseQty = sum;
      }
      setListLength(data.lineList.length);
    }
    setLineList(data.lineList);
  };

  //获取自定义字段设置
  // async function getFieldSetting(customerCode) {
  //   await CustFieldService.getSetting(companyCode, customerCode, true, 19).then(
  //     rs => {
  //       if (rs) {
  //         let _fieldSetting = rs;
  //         setFieldSetting(_fieldSetting);
  //       }
  //     }
  //   );
  // }

  //获取自定义字段设置
  function getFieldSetting(data) {
    let customerCode;
    if (!self.isPurchase) {
      customerCode = data.customerCode;
    }
    //获取自定义字段
    CustFieldService.getSetting(
      companyCode,
      customerCode,
      true,
      19,
      dispatch
    ).then(rs => {
      if (rs) {
        let fieldData = rs;
        if (Array.isArray(fieldData.list)) {
          fieldData.list.forEach(item => {
            //单头单身日期字段，转换为时间戳
            CustFieldService.parseCustFields(
              fieldData,
              data,
              data.lineList,
              self.isPurchase
            );
          });
        }
        setFieldSetting(fieldData);

        // let arr = DeliveryFns.parseLineList(data.lineList);
        // let cCode = self.isPurchase ? companyCode : data.customerCode;
        // // 计算送货单单身显示字段是否开启，是否必填
        // CustFieldService.checkBodyNormalFieldOpen(cCode, arr, fieldData).then(
        //   () => {
        //     setLineList(arr);
        //   }
        // );
      }
    });
  }

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //是否开启采购组织
  function getIsOpenOrg(purCompanyCode) {
    let postbody = {
      companyCode: purCompanyCode,
      apiPath: '/archives/sysCtrParam/checkOpenOrg'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        setIsOpenOrg(response.data);
        getIsOpenProfit(); //获取是否开启工厂
      }
    });
  }

  //是否开启工厂
  function getIsOpenProfit() {
    let postbody = {
      companyCode: detail.purCompanyCode,
      apiPath: '/archives/sysCtrParam/checkOpenProfit'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        setIsOpenProfit(response.data);
      }
    });
  }

  //获取请购需求池设置的物料分类
  function getCurCategoryType(purCompanyCode) {
    let prodCategoryType;
    let postbody = {
      companyCode: purCompanyCode,
      categoryType: '',
      apiPath: '/req2pur/assignRule/list'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        prodCategoryType = response.data?.prodCategoryType;
        setCurCategoryType(prodCategoryType);
      }
    });
  }

  // 同步单身数据
  function syncBodyData(arr) {
    arr.forEach(item => {
      //工厂同步至采购部门
      if (!isEmpty(detail.plantCode)) {
        item.profitCenterCode = detail.plantCode;
        item.profitCenterName = detail.plantName;
      }
      //请购类型 & 采购类型
      if (!isEmpty(detail.reqInnerTypeCode)) {
        item.reqInnerTypeCode = detail.reqInnerTypeCode;
        item.reqInnerTypeName = detail.reqInnerTypeName;
        item.purchaseType = detail.purchaseType;
        item.isFreebieEdit = detail.isFreebieEdit === '1' ? '1' : '0'; //根据单头请购类型赠品否参数锁定单身赠品否是否可编辑，并重置页面
        if (item.isFreebieEdit === '0') {
          item.isFreebie = 0;
        }
      }
    });
    setLineList(arr);
  }

  // 添加新物料
  function AddNewProd() {
    lineList.push({
      newFlag: 1,
      productCode: '',
      productName: '',
      productScale: '',
      reqInnerTypeCode: !isEmpty(detail.reqInnerTypeCode)
        ? detail.reqInnerTypeCode
        : null,
      reqInnerTypeName: !isEmpty(detail.reqInnerTypeName)
        ? detail.reqInnerTypeName
        : null,
      costCenterCode: !isEmpty(detail.costCenterCode)
        ? detail.costCenterCode
        : null, //成本中心
      costCenterName: !isEmpty(detail.costCenterName)
        ? detail.costCenterName
        : null,
      isFreebie: detail.isFreebieEdit === '1' ? '1' : '0',
      bodyExtend: {
        extendN10: undefined
      }
    });
    syncBodyData(lineList); //同步单身数据
    setLineList(lineList.concat([]));
  }

  // 弹窗添加物料
  function popAddProd() {
    setShowAddProd(true);
  }

  // 添加物料完毕
  function handleProdChange(list) {
    let arr = list.map(item => {
      item.productName = item.prodName;
      item.productCode = item.prodCode;
      item.productScale = item.prodScale;
      item.reqUnitName = item.basicUnitName;
      item.reqUnitCode = item.basicUnitCode;
      item.reqValuationUnitCode =
        item.purchaseUnitCode || item.purchaseUnitName || item.basicUnitCode;
      item.reqValuationUnitName = item.purchaseUnitName || item.basicUnitName;
      item.companyCode = companyCode;
      item.feature = item.compProdFeatureStr; //特征码
      item.newFlag = item.newFlag ? 1 : 0;
      item.reqInnerTypeCode = !isEmpty(detail.reqInnerTypeCode)
        ? detail.reqInnerTypeCode
        : null;
      item.reqInnerTypeName = !isEmpty(detail.reqInnerTypeName)
        ? detail.reqInnerTypeName
        : null;
      item.costCenterCode = !isEmpty(detail.costCenterCode)
        ? detail.costCenterCode
        : null; //成本中心
      item.costCenterName = !isEmpty(detail.costCenterName)
        ? detail.costCenterName
        : null;

      item.bodyExtend = {
        extendN10: undefined
      };
      item.isFreebie = detail.isFreebieEdit === '1' ? '1' : '0';
      item.demandDate = '';
      item.reqQty = '';
      return item;
    });

    //添加已有物料时获取物料分类、采购员
    let selProdCodes = arr.map(item => item.productCode);
    let postbody2 = {
      apiPath: '/archives/compProd/getProdCategoryAndBuyerCode',
      prodCodeList: selProdCodes,
      categoryType: curCategoryType,
      companyCode: companyCode
    };
    Http.post('/api/cloudCenter', postbody2).then(response => {
      if (response.success) {
        let data = response.data;
        if (!Util.isEmpty(data)) {
          arr.forEach(arrItem => {
            data.forEach(dataItem => {
              if (dataItem.prodCode === arrItem.productCode) {
                arrItem.prodCategoryCode = dataItem.prodCategoryCode;
                arrItem.prodCategoryName = dataItem.prodCategoryName;
                // arrItem.buyerEmpName = dataItem.buyerName;
                // arrItem.buyerEmpXkuniquecodes = dataItem.buyerCodes;
                syncBodyData(lineList); //同步单身数据
                setLineList(lineList.concat(arr));
              }
            });
          });
        }
      }
    });

    syncBodyData(lineList); //同步单身数据
    setLineList(lineList.concat(arr));
  }

  // 编辑单身项次
  function openLineEdit(item) {
    setCurrItem(item);
    setLineEdit(true);
  }

  // 删除单身项次
  function deleteLine(index) {
    ModalService.showConfirm(
      '确定删除此明细？',
      () => {
        lineList.splice(index, 1);
        setLineList(lineList.concat([]));
      },
      dispatch
    );
  }

  // 保存单身项次
  function saveLine(data) {
    // console.log(data);
  }

  // 编辑单头
  function openEdit() {
    setEdit(true);
  }

  // 保存单头
  function saveHead(data) {}

  // 保存
  function save() {
    if (!check()) {
      return;
    }
    lineList.forEach(item => {
      item.newFlag = item.newFlag ? 1 : 0;
      if (typeof item.productCode === 'string') {
        item.productCode = item.productCode.trim();
      }
      delete item.erpCategoryList;
      delete item.storeList;
      delete item.extendFieldsList;
    });
    detail.lineList = lineList;
    let postbody = {
      apiPath: '/b2bRequisitionOrder/save',
      ...detail,
      purchaseType: 0,
      companyCode
    };
    Http.post('/api/cloudCenter?btnId=002', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //发布
  function publish() {
    if (!check()) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      reqXkNo: detail.reqInnerNo
    };
    OrderService.publishRequisition(
      postbody,
      () => {
        // self.getDetail();
        setRedirect('/mp/purchase/requisition/list');
      },
      dispatch
    );
  }

  function check() {
    if (
      !CustFieldService.validate(detail, lineList, fieldSetting, true, dispatch)
    ) {
      return;
    }
    let res = true;
    let checkFields = {
      productName: '物料名称不能为空'
    };
    Object.keys(checkFields).some(key => {
      if (lineList.some(item => !item[key])) {
        res = false;
        ModalService.showError(checkFields[key], dispatch);
      }
      return res === false;
    });
    return res;
  }

  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = obj.reqXkNo,
      xkNo = obj.reqXkNo,
      lineNo = obj.lineNo,
      cCode = obj[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //路由跳转
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
            <div className="more">
              <span
                className={
                  'u-sign ' +
                  CommonFns.getStatusClass('requisition', detail.status)
                }
              >
                {detail.statusName}
              </span>
              {/* 编辑单头 */}
              {User.checkAuth('10010802') &&
                [0, 8].includes(detail.status) &&
                workflow.data?.requisition_publish?.canEdit && (
                  <i onClick={openEdit} className="icon-edit"></i>
                )}
            </div>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">平台单号</span>
                  <div className="field-value">{detail.reqXkNo}</div>
                </li>
                <li>
                  <span className="field-label">请购公司</span>
                  <div className="field-value">{detail.purCompanyName}</div>
                </li>
                {isOpenOrg && (
                  <li>
                    <span className="field-label">采购组织</span>
                    <div className="field-value">{detail.erpOrgName}</div>
                  </li>
                )}
                {isOpenProfit && (
                  <li>
                    <span className="field-label">工厂</span>
                    <div className="field-value">{detail.plantName}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">请购类型</span>
                  <div className="field-value">{detail.reqInnerTypeName}</div>
                </li>
                <li>
                  <span className="field-label">请购日期</span>
                  <div className="field-value">
                    {formatDate(detail.reqDate)}
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase &&
                  updateTs > 0 &&
                  listLength > 0 &&
                  workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                <li>
                  <span className="field-label">ERP单号</span>
                  <div className="field-value">{detail.reqInnerNo}</div>
                </li>
                <li>
                  <span className="field-label">来源单号</span>
                  <div className="field-value">{detail.sourceOrderNo}</div>
                </li>
                <li>
                  <span className="field-label">收货地点</span>
                  <div className="field-value">{detail.receivePlaceName}</div>
                </li>
                <li>
                  <span className="field-label">备注</span>
                  <div className="field-value">{detail.remark}</div>
                </li>
                {detail.attachCount > 0 && (
                  <li>
                    <span className="field-label">附件</span>
                    <div className="field-value">
                      <span
                        className="attachment"
                        onClick={() => showFileList(163, detail)}
                      >
                        {detail.attachCount}个附件
                        <i className="icon-attachment"></i>
                      </span>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          {/* 单头自定义 */}
          <HeadCustField
            fieldSetting={fieldSetting}
            detail={detail}
            setDetail={setDetail}
            isEdit={
              User.checkAuth('10010802') &&
              [0, 8].includes(detail.status) &&
              workflow.data?.requisition_publish?.canEdit
            }
            isPurchase={self.isPurchase}
          ></HeadCustField>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>请购明细</label>
          </div>
          <div className="details-item-content">
            {lineList?.map((item, index) => (
              <div
                className="content-line line-list-item"
                key={String(item.id) + index}
              >
                <div className="line-list-item-title">
                  <span>项次{item.lineNo}</span>
                  {User.checkAuth('10010802') &&
                    [0, 8].includes(detail.status) &&
                    workflow.data?.requisition_publish?.canEdit && (
                      <div className="more">
                        <i
                          className="icon-edit"
                          onClick={() => {
                            openLineEdit(item);
                          }}
                        ></i>
                        <i
                          className="icon-delete"
                          onClick={() => {
                            deleteLine(index);
                          }}
                        ></i>
                      </div>
                    )}
                </div>
                <ul className="field-list">
                  <li>
                    <span className="field-label">物料编码</span>
                    <div className="field-value">{item.productCode}</div>
                  </li>
                  <li>
                    <span className="field-label">物料名称</span>
                    <div className="field-value">{item.productName}</div>
                  </li>
                  <li>
                    <span className="field-label">物料规格</span>
                    <div className="field-value">{item.productScale}</div>
                  </li>
                  <li>
                    <span className="field-label">物料分类</span>
                    <div className="field-value">{item.prodCategoryName}</div>
                  </li>
                  <li>
                    <span className="field-label">请购数量</span>
                    <div className="field-value">
                      {item.reqQty
                        ? formatNumber(item.reqQty, decimalPlace.QTY)
                        : '--'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">请购单位</span>
                    <div className="field-value">
                      {item.initReqUnitName || item.reqUnitName || '--'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">需求时间</span>
                    <div className="field-value">
                      {formatDate(item.demandDate)}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">请购类型</span>
                    <div className="field-value">{item.reqInnerTypeName}</div>
                  </li>
                  <li>
                    <span className="field-label">转采数量</span>
                    <div className="field-value">
                      {formatNumber(item.sumPurchaseQty, decimalPlace.QTY)}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">预估单价</span>
                    <div className="field-value">
                      {' '}
                      {item.estimatePrice
                        ? formatNumber(item.estimatePrice, decimalPlace.PRICE)
                        : '--'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">预估金额</span>
                    <div className="field-value">
                      {' '}
                      {item.estimateAmount
                        ? formatNumber(item.estimateAmount, decimalPlace.AMOUNT)
                        : '--'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">备注</span>
                    <div className="field-value">{item.remark}</div>
                  </li>
                  <li>
                    <span className="field-label">品牌</span>
                    <div className="field-value">{item.brandName}</div>
                  </li>
                  <li>
                    <span className="field-label">用途</span>
                    <div className="field-value">{item.purpose}</div>
                  </li>
                  <li>
                    <span className="field-label">WBS</span>
                    <div className="field-value">{item.wbsName}</div>
                  </li>
                  {!Util.isEmpty(fieldSetting?.bodyCustList) &&
                    fieldSetting.bodyCustList.map((extend, i) => (
                      <li key={i}>
                        <span className="field-label">{extend.transName}</span>
                        <div className="field-value">
                          {item[extend.fieldCode]}
                        </div>
                      </li>
                    ))}
                </ul>
                {item.infoList && item.infoList.length > 0 && (
                  <div className="order-detail-more">
                    {item.infoList.map((info, i) => (
                      <ul className="field-list" key={String(info.id) + i + 1}>
                        <li>
                          <span className="field-label">采购单号</span>
                          <div className="field-value">
                            <Link
                              to={`${config.orderDetailLink}/${companyCode}/${info.poXkNo}`}
                              key={item.id}
                              className="m-list-item"
                            >
                              {info.poErpNo}
                            </Link>
                          </div>
                        </li>
                        <li>
                          <span className="field-label">采购交期</span>
                          <div className="field-value">
                            {formatDate(info.expectedDate)}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">数量</span>
                          <div className="field-value">{info.purchaseQty}</div>
                        </li>
                      </ul>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {User.checkAuth('10010802') &&
          [0, 8].includes(detail.status) &&
          workflow.data?.requisition_publish?.canEdit &&
          detail.sourceOrderType !== 1 && (
            <div className="btn-container">
              <span
                className="btn btn-white"
                onClick={() => {
                  popAddProd();
                }}
              >
                <i className="icon-add"></i>
                添加已有物料
              </span>
              {User.checkAuth('10010806') && (
                <span
                  className="btn btn-white"
                  onClick={() => {
                    AddNewProd();
                  }}
                >
                  <i className="icon-add"></i>
                  添加新物料
                </span>
              )}
            </div>
          )}
      </div>
      {/* 底部按钮容器 */}
      {[0, 8].includes(detail.status) && (
        <div className="btn-container btn-fixed-container">
          <div className="left-wrap">
            <Link to="/mp/purchase/requisition/list">
              <i className="icon-left"></i>
              返回
            </Link>
          </div>
          <div className="right-wrap">
            {User.checkAuth('10010802') &&
              workflow.data?.requisition_publish?.canEdit && (
                <button
                  onClick={() => {
                    save();
                  }}
                  className="btn"
                >
                  保存
                </button>
              )}
            {/* 发布（审批流程）*/}
            {User.checkAuth('10010803') &&
              workflow.data?.requisition_publish?.complete && (
                <button
                  onClick={() => {
                    publish();
                  }}
                  className="btn btn-big"
                >
                  发布
                </button>
              )}
          </div>
        </div>
      )}
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>

      {/* 单头编辑弹窗 */}
      <DialogEditRequisiton
        companyCode={companyCode}
        detail={detail}
        open={edit}
        fieldSetting={fieldSetting}
        onComplete={data => {
          saveHead(data);
        }}
        onClose={() => setEdit(false)}
      ></DialogEditRequisiton>

      {/* 单身项次编辑弹窗 */}
      <DialogEditRequisitonLine
        companyCode={companyCode}
        currItem={currItem}
        open={lineEdit}
        fieldSetting={fieldSetting}
        onComplete={data => {
          saveLine(data);
        }}
        onClose={() => setLineEdit(false)}
      ></DialogEditRequisitonLine>

      {/* 添加已有物料弹窗 */}
      <DialogAddProd
        companyCode={detail.purCompanyCode}
        open={showAddProd}
        onComplete={data => {
          handleProdChange(data);
        }}
        onClose={() => setShowAddProd(false)}
      ></DialogAddProd>
    </div>
  );
}

RequisitionDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequisitionDetail);
